<template>
	<div></div>
</template>
<script>
export default {
	name: "bg"
};
</script>
<style scoped>
div {
	position: fixed;
	width: 100%;
	height: 100vh;
	background: transparent url(../../static/main_bg.png) no-repeat center;
	background-size: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/Bg.vue